import React from "react";

import NewClassDialog from "./NewClassDialog";
import HomeworkDialog from "./HomeworkDialog";
import MilestoneValidationDialog from "./MilestoneValidationDialog";
import CreateHomeworkDialog from "./CreateHomeworkDialog";
import CreateHomeworkListDialog from "./CreateHomeworkListDialog";
import { useHomework } from "../../context/homework";

// List of application-wide dialogs
function Dialogs() {
  const [homework] = useHomework();

  // TODO : This could be better... (no transition out)
  if (homework.activity) {
    return null;
  }

  return (
    <>
      <NewClassDialog />
      <HomeworkDialog />
      <MilestoneValidationDialog />
      <CreateHomeworkDialog />
      <CreateHomeworkListDialog />
    </>
  );
}

export default Dialogs;
